import { api, apiUrl } from "../../shared/services/service";
import type {
  AdminOnboardingDeleteRequest,
  AdminOnboardingDeleteResult,
  AdminOnboardingRecord,
} from "../models/admin-onboarding.models";
import axios from "axios";

export async function getAdminOnboardingRows(signal: AbortSignal): Promise<AdminOnboardingRecord[]> {
  const response = await api.get<{ rows: AdminOnboardingRecord[] }>(`${apiUrl}/admin/debug/onboarding`, { signal });
  return response.data.rows;
}

export async function deleteAdminOnboardingVessel(
  request: AdminOnboardingDeleteRequest,
): Promise<AdminOnboardingDeleteResult> {
  const response = await api.post<AdminOnboardingDeleteResult>(`${apiUrl}/admin/debug/onboarding/delete`, request);
  return response.data;
}

export function getAdminOnboardingErrorMessage(error: unknown): string {
  if (axios.isAxiosError(error)) {
    const response = error.response?.data as { error?: string; message?: string } | string | undefined;
    return typeof response === "string" ? response : response?.error ?? response?.message ?? error.message;
  }

  return error instanceof Error ? error.message : "Onboarding request failed.";
}
